import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "col-12 bg-danger-teres p-3 justify-content-center",
  role: "alert"
}
const _hoisted_3 = { class: "d-block w-100 mb-2" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.showButton)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.showConfirmation)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showConfirmation = !_ctx.showConfirmation)),
              class: "btn btn-brand1"
            }, _toDisplayString(_ctx.$t(_ctx.i18nMessage)), 1))
          : _createCommentVNode("", true),
        (_ctx.showConfirmation)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.panicLong')), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showConfirmation = !_ctx.showConfirmation)),
                  class: "btn btn-danger-cancel mr-3"
                }, _toDisplayString(_ctx.$t('common.cancel')), 1),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onClick())),
                  class: "btn btn-outline-danger"
                }, _toDisplayString(_ctx.$t(_ctx.i18nMessage)), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}